<script>
// eslint-disable-next-line
import { OvalStencil } from './index';

export default {
  // CANNOT be called "CircleStencil" as it clashes with
  // vue advanced cropper's CircleStencil.
  name: 'SlCircleStencil',
  extends: OvalStencil,
  methods: {
    aspectRatios() {
      const max = 1;
      return {
        minimum: 1 / max,
        maximum: max,
      };
    },
    processCrop: OvalStencil.methods.processCrop,
  },
};

</script>
